import { Component } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { filter } from 'rxjs';

import { UserService } from '../../../services/user/user.service';
import { User } from '../../../interfaces/user';
import { InputComponent } from '../../../shared/input/input.component';
import { NotificationSettingsComponent } from './notification-settings/notification-settings.component';
import * as userProfileConstants from '../../../shared/constants/myprofileconstants';

@Component({
  selector: 'app-my-profile',
  standalone: true,
  imports: [InputComponent, NotificationSettingsComponent],
  templateUrl: './my-profile.component.html',
  styleUrl: './my-profile.component.css',
})
export class MyProfileComponent {
  name = new FormControl({ value: '', disabled: true });
  textInputType = userProfileConstants.TEXT_INPUT_TYPE;
  nameLabel = userProfileConstants.NAME_LABEL;
  email = new FormControl({ value: '', disabled: true }, Validators.email);
  emailInputType = userProfileConstants.EMAIL_INPUT_TYPE;
  emailLabel = userProfileConstants.EMAIL_LABEL;
  mailIcon = userProfileConstants.MAIL_ICON;

  phone = new FormControl({ value: '', disabled: true });
  phnLabel = userProfileConstants.PHN_LABEL;
  phnStyle = userProfileConstants.PHN_STYLE;
  phoneIcon = userProfileConstants.PHN_ICON;

  orgName = new FormControl({ value: '', disabled: true });
  orgnameLabel = userProfileConstants.ORGNAME_LABEL;
  accountCircleIcon = userProfileConstants.ACCOUNT_CIRCLE_ICON;
  orgNamePlaceholder = userProfileConstants.ORGNAME_PLACEHOLDER;

  constructor(private userService: UserService) {
    this.userService.user$
      .pipe(
        filter((user): user is User => user !== null),
        takeUntilDestroyed()
      )
      .subscribe((user) => {
        this.name.setValue(user.name);
        this.email.setValue(user.email);
        this.phone.setValue(user.phone);
        this.orgName.setValue(user.orgName);
      });
  }

  handleCallback(_event: any) {}
}
